module.exports = __webpack_public_path__ + "img/blue.a2c87e44.png";